import React, { useEffect, useState } from 'react';

/* Animated cursor glow that follows the mouse */
function CursorGlow() {
  const [pos, setPos] = useState({ x: -100, y: -100 });

  useEffect(() => {
    const handleMove = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        left: pos.x - 150,
        top: pos.y - 150,
        width: 300,
        height: 300,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,212,255,0.06) 0%, rgba(168,85,247,0.03) 40%, transparent 70%)',
        pointerEvents: 'none',
        zIndex: 1,
        transition: 'left 0.1s ease-out, top 0.1s ease-out',
        willChange: 'left, top',
      }}
    />
  );
}

export default CursorGlow;
